import cx from 'classnames';
import * as React from 'react';

import styles from './Table.module.scss';

interface Props {
  children: any;
}

export const TablePanel: React.FC<Props> = ({ children })=> (
  <div className={styles.table_panel}>
    {children}
  </div>
);

export const TableFilters: React.FC = props => (
  <div className={styles.table_panel_filters} {...props} />
);

export interface TableFilterProps {
  right: boolean;
  left: boolean;
  search: boolean;
  minSearch: boolean;
  children: any
}

export const TableFilter: React.FC<Partial<TableFilterProps>> = ({
  left,
  right,
  search,
  minSearch,
  children,
  ...other
}) => (
  <div
    className={cx({
      [styles.table_panel_filter]: true,
      [styles.table_panel_filter_search]: search,
      [styles.table_panel_filter_minSearch]: minSearch,
      [styles.table_panel_filter_left]: left,
      [styles.table_panel_filter_right]: right
    })}
    {...other}
  >
    {children}
  </div>
);

export const TablePanelSeparator: React.FC = () => (
  <div className={styles.table_panel_separator}/>
);
